import React from 'react';

import classes from './PaypalFooter.scss';

import paypalFooterImage from '../../../../assets/images/payments/paypal/paypal-footer.svg';

const paypalFooter = () => (
    <div>
        <img src={paypalFooterImage} alt='Paypal' className={classes.Image}/>
    </div>
);

export default paypalFooter;


// WEBPACK FOOTER //
// ./src/components/Payment/Paypal/PaypalFooter/PaypalFooter.js